export function formatPrice(price: number, delimeterSymbol = ',', currencySymbol = '$'): string {
  const negative = price < 0;
  price = Math.abs(price);

  const integerPart = Math.trunc(price);

  const fractionalPart = Math.trunc((price - integerPart) * 100);
  let fractionalPartString = fractionalPart.toString();
  if (fractionalPartString.length < 2) {
    fractionalPartString = '0' + fractionalPartString;
  }

  return (negative ? '-' : '') + currencySymbol + integerPart.toString() + delimeterSymbol + fractionalPartString;
}
